import { Link, useHistory } from "react-router-dom"

export const NoAccessPage=()=>{
    let history = useHistory()
    return <div className="no-access-page">
        <h1>Err!!</h1>
        <h3>Looks like you dont have access to the page.</h3>
        <Link onClick={() => history.goBack()}>Go Back</Link>
    </div>
}